var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk39S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "-5 -5 44 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M32.679 14.021c-.03-.79-1.28-1.118-1.572-1.235-.293-.117-.454-.3-.344-.563.168-.388.826-.161 1.067.021.468.344 1.024-.307.622-.716-.285-.3-1.046-.446-1.44-.395-.702.103-1.244.563-1.273 1.265-.05 1.031.995 1.082 1.63 1.39.19.087.388.27.293.496-.102.264-.482.22-.672.198-.22-.03-.432-.132-.644-.285-.417-.307-.958.197-.702.636.22.38.944.629 1.36.636.848.007 1.711-.57 1.675-1.448Zm-3.563-3.553c.205.124.27.388.153.592l-.504.849a.423.423 0 0 1-.585.146.438.438 0 0 1-.154-.592l.505-.849a.42.42 0 0 1 .585-.146Z",
    fill: "#330303",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.049 1.716c6.478 0 11.728 5.279 11.728 11.801s-5.25 11.794-11.728 11.794-11.72-5.279-11.72-11.794c0-6.515 5.249-11.801 11.72-11.801Z",
    fill: "#D9016E",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.717 17.18c-.49-1.521-.476-3.188.19-5.14 1.053-3.071 4.19-4.987 6.01-5.236 1.82-.241 2.406-.124 3.766-.146 1.352-.022 2.427-.059 3.32-.095.891-.044 3.538.307 5.359 3.173 1.82 2.866 1.133 7.18-.358 9.301-1.909 2.69-3.554 3.298-6.552 3.59-4.906.483-10.003-.088-11.735-5.447Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.234 4.977c.549.716.27 1.93-.614 2.713-.885.782-2.04.826-2.588.11-.549-.717-.271-1.931.614-2.713.885-.776 2.04-.827 2.588-.11Z",
    fill: "#FCC3CA",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.108 17.911s.9 1.77 2.8 1.799c1.901.029 3.225-1.01 3.598-2.31.402-1.368-.242-2.691-1.463-3.24 2.165-1.799.914-4.76-1.813-4.606-1.777.102-2.64.95-2.983 1.63-.344.688-.037 1.36.424 1.463.46.102.79-.176.965-.659.176-.482.527-1.14 1.316-1.14.79 0 1.39.526 1.397 1.243.014 1.25-.995 1.477-2.004 1.477-.877 0-.892 1.316-.168 1.367.234.022 1.177.007 1.404.022.227.007 1.038.336 1.163 1.243.168 1.221-.57 2.245-1.638 2.2-.973-.036-1.265-.664-1.616-1.476-.176-.417-.351-.84-.907-.804-.497.022-1.111.672-.475 1.791ZM23.65 14.97c-1.3 2.326-5.257 1.156-5.14-2.134.073-2.157 1.638-3.29 3.254-3.32a3.48 3.48 0 0 1 3.122 1.777c.82 1.448.79 4.724.015 6.266-.607 1.207-1.645 2.048-2.706 2.106-1.22.066-2.478-.38-3.166-1.418-.095-.22-.168-.468-.146-.724.051-.702.688-.834 1.031-.702.395.146.497.49.68.797.358.592.804.833 1.338.79 1.236-.117 1.792-2.465 1.719-3.437Zm-1.842-4.043c.885 0 1.616.878 1.63 1.96.015 1.082-.694 1.96-1.579 1.96s-1.616-.878-1.63-1.96c-.015-1.082.694-1.96 1.579-1.96Z",
    fill: "#330303",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.361 24.762c1.412-.307 2.8.6 3.1 2.018a2.635 2.635 0 0 1-2.01 3.122c-1.411.3-2.8-.6-3.1-2.025-.3-1.419.6-2.815 2.01-3.115Z",
    fill: "#FF9721",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.75 25.581c1.03-.22 2.04.439 2.259 1.47a1.923 1.923 0 0 1-1.463 2.274c-1.023.227-2.04-.439-2.26-1.47a1.905 1.905 0 0 1 1.463-2.274Zm.043.22a1.673 1.673 0 0 1 1.989 1.294 1.694 1.694 0 0 1-1.287 2.003 1.673 1.673 0 0 1-1.989-1.294 1.698 1.698 0 0 1 1.287-2.003Z",
    fill: "#FFEDB5",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24.357 28.374.132-1.47-.161.037-.058-.241.336-.176.314.059-.16 1.843-.403-.052Zm1.236.139.044-.351-.673-.08-.015-.286.87-1.148.315.03-.08 1.206.153.03-.059.3-.168-.023-.051.366-.336-.044Zm.139-.658.087-.592-.424.54.337.052Z",
    fill: "#FFEDB5",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M30.754 18.05c1.792 0 3.247 1.462 3.247 3.268 0 1.806-1.455 3.269-3.247 3.269-1.791 0-3.246-1.463-3.246-3.269a3.249 3.249 0 0 1 3.246-3.268Z",
    fill: "#60C",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.922 19.542c1.024-.03 1.88.782 2.07 1.886-.015.49-.14.958-.344 1.368.102-.264.16-.556.16-.856 0-1.148-.81-2.062-1.82-2.033-1.009.03-1.82.98-1.82 2.128 0 1.148.811 2.062 1.82 2.033a1.69 1.69 0 0 0 .943-.322 3.349 3.349 0 0 1-.994.622h-.008c-1.162.029-2.113-1.024-2.113-2.355 0-1.33.944-2.442 2.106-2.471Z",
    fill: "#CCF",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m32.423 20.675-.841.57.22 1.272.416-.117c-.036-.321.49-.387.432.147-.03.226-.169.431-.432.226l-.424.198s.183.3.6.27c.41-.022.702-.438.658-.98-.044-.533-.512-.672-.68-.6-.169.074-.198.133-.198.133l-.05-.41.423-.314-.124-.395Z",
    fill: "#CCF",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.116 21.224a3.047 3.047 0 0 1 3.042 3.056 3.047 3.047 0 0 1-3.042 3.056A3.047 3.047 0 0 1 .074 24.28a3.052 3.052 0 0 1 3.042-3.056Z",
    fill: "#0486E4",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.98 22.071c.783.79.74 2.113-.109 2.969-.848.855-2.164.907-2.954.124-.79-.782-.738-2.113.102-2.968.856-.856 2.18-.907 2.962-.125Zm-.19.125c.703.709.666 1.9-.094 2.668-.76.768-1.945.82-2.655.11-.702-.702-.665-1.9.095-2.669.76-.767 1.945-.819 2.655-.11Z",
    fill: "#DFF8F4",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.866 24.667c.183-.636.468-1.243.724-1.857l-.3-.095c-.153.073-.395.16-.57.146l-.059.322c.08.007.176.022.351-.008-.285.395-.49 1.046-.563 1.397 0 .007.249.015.417.095Zm-.754-.227-1.038-.475.263-.57s.673-.213.827-.315a.275.275 0 0 0 .05-.431c-.138-.132-.365.021-.423.168l-.315-.059s.242-.358.622-.38c.38-.022.658.329.482.746-.175.417-1.001.453-1.016.519-.015.066.051.117.051.117l.607.278-.11.402Z",
    fill: "#DFF8F4",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.636.041c1.484 0 2.69 1.214 2.69 2.713a2.696 2.696 0 0 1-2.69 2.705 2.7 2.7 0 0 1-2.69-2.705c0-1.5 1.206-2.713 2.69-2.713Z",
    fill: "#3C6",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.49.794a1.97 1.97 0 0 1 1.967 1.981A1.975 1.975 0 0 1 3.49 4.757a1.982 1.982 0 0 1 0-3.963Zm0 .27c.936 0 1.696.768 1.696 1.711A1.7 1.7 0 0 1 3.49 4.48a1.7 1.7 0 0 1-1.697-1.704c0-.943.76-1.71 1.697-1.71Z",
    fill: "#9F9",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.41 3.917.359-.234-.958-1.47-.264.139c.015.16-.124.424-.219.556l.27.182.125-.248.687 1.075Zm-.306-1.478-.198-.33 1.002-.635.249.358c-.08.307.095 1.162.255 1.426l-.35.248c-.213-.482-.359-.936-.337-1.47l-.621.403Z",
    fill: "#9F9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk39S);
export default __webpack_public_path__ + "static/media/uk_39s.2faf3cd46259e9691effab52cdd6c234.svg";
export { ForwardRef as ReactComponent };